import Button from '@mui/material/Button'
import type { SxProps, Theme } from '@mui/material/styles'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { defaultTheme } from '../../theme/default.theme'
import { get } from 'lodash'

export const UButton = styled(Button)(
    ({ sx }: { sx?: SxProps<Theme> }) => css`
        background-color: ${get(sx, 'backgroundColor') as string || defaultTheme.palette.primary.light};
        color: ${defaultTheme.palette.primary.contrastText};
        border-radius: ${get(sx, 'borderRadius') as string || '99px'};
        box-shadow: none;
        font-size: ${defaultTheme.typography.body1.fontSize};
        font-weight: 700;
        text-transform: none;
    `
)

export const UButtonError = styled(Button)(
    () => css`
        background-color: ${defaultTheme.palette.error.main};
        color: ${defaultTheme.palette.error.contrastText};
        border-radius: 99px;
        box-shadow: none;
        font-size: ${defaultTheme.typography.body1.fontSize};
        font-weight: 700;
        text-transform: none;
        height: 40px;
    `
)

export const UButtonSecondary = styled(Button)(
    () => css`
        background-color: ${defaultTheme.palette.background.default};
        color: ${defaultTheme.palette.primary.main};
        border-radius: 99px;
        box-shadow: none;
        font-size: ${defaultTheme.typography.body2.fontSize};
        font-weight: 500;
        border: 1px solid rgba(229, 231, 235, 1);
        text-transform: none;
        height: 40px;
    `
)
